import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppLoginContainerModel} from '../../../../../models/aggregates/id';

@Injectable({providedIn: 'root'})
export class EcomRegistrationService extends BaseApiTemplateService<AppLoginContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_ECOM_URL_PREFIX + 'identity/registration';
    this.endpoint_path = Core2Config.TENANT_ECOM_URL_PREFIX + 'identity/registration';
    this.httpClient = http;
  }

}
